import customFunc from '../util/util'
import Picc from '../util/pulicInsuranceOfPICC'

/**
 * 获取该保障计划支持的职业类型
 * */
const getProfessionTypes = function (careerType, duration, planList, rules, isAX, clausePremium, deductible, deductibleRate, disabledRate = null) {
    if (isAX) {
        return [1]
    }
    if (!duration || !planList) {
        return []
    }
    let list = []
    let list2 = []
    let result = []
    let Dkey = 'D_' + duration.duration + duration.durationUnit

    let db_key = deductible !== null ? '_DB_' + deductible : ''
    let dr_key = deductibleRate !== null ? '_DR_' + deductibleRate : ''
    let ddr_key = disabledRate !== null ? '_DDR_' + disabledRate : ''

    for (let type of careerType) {
        list.push(Dkey + '_P_' + type)
    }
    if (db_key || dr_key || ddr_key) {
        for (let type of list) {
            list2.push(type + db_key + dr_key + ddr_key)
        }
    }
    // console.log('getProfessionTypes - rules', rules)
    // console.log('getProfessionTypes - list', list)
    // console.log('getProfessionTypes - planList', planList)
    for (let [_index, key] of list.entries()) {

        let professionPass = true
        let item = clausePremium[key]
        // console.log('item ======', item)
        // console.log('key ======', key)
        if (!item) {
            // console.log(key ,'不存在')
            continue
        }
        if (list2.length > 0 && list2[_index] != key) {
            item = item.concat(clausePremium[list2[_index]] || [])
        }
        let keyArray = key.split('_')
        for (let plan of planList) {
            // console.log('plan ======', plan)
            if (plan.merge) {

                continue
            }
            let sameClause = item.filter(clause => {
                return clause.clauseCode === plan.clauseCode
            })[0]
            if (!sameClause) {
                console.log('找不到', key, plan.clauseName)
                professionPass = false
                continue
            } else {

                let sameInsured = sameClause.groupProductPremiumList.filter(premium => {
                    return premium.insured === plan.selected.insured
                })[0]
                // console.log('sameClause.groupProductPremiumList ======', sameClause.groupProductPremiumList)
                // console.log('plan.selected.insured ======', plan.selected.insured)
                if (!sameInsured) {
                    // console.log('sameInsured ======', !sameInsured)
                    professionPass = false
                    break
                }
            }
        }
        // console.log('professionPass=======', professionPass)
        if (professionPass) {
            result.push(keyArray[3])
        }
    }

    let disabledProfessionTypes = []
    let allDisable = false

    const setDisabledProfessionTypes = function (levelVal) {
        if (levelVal) {
            disabledProfessionTypes.push(levelVal)
        } else {
            allDisable = true
        }
    }

    for (let rule of rules) {
        const maxPlan = planList.filter(plan => {
            return plan.clauseCode === rule.dutyMax
        })[0]
        const minPlan = planList.filter(plan => {
            return plan.clauseCode === rule.dutyMin
        })[0]

        if (!maxPlan || !minPlan) {
            continue
        }

        let maxPlanPrice = maxPlan.selected.insured * maxPlan.insuredRate;
        let minPlanPrice = minPlan.selected.insured * minPlan.insuredRate;

        if (rule.max && ( maxPlanPrice > rule.max || maxPlanPrice < rule.min)) {
            setDisabledProfessionTypes(rule.levelVal)
            continue
        }

        if (rule.static) {
            if ((maxPlanPrice * rule.rate).toFixed(2) != minPlanPrice && minPlanPrice) {
                setDisabledProfessionTypes(rule.levelVal)
                continue
            }
        } else {
            if (maxPlanPrice * rule.rate < minPlanPrice) {
                setDisabledProfessionTypes(rule.levelVal)
                continue
            }
        }
    }

    // 找出合并的责任支持的职业类型
    let mergeRulesProfessionTypes = null
    let mergeRules = rules.filter(item => {
        return item.merge
    })
    if (mergeRules.length) {
        mergeRulesProfessionTypes = []
        for (let rule of mergeRules) {
            let clause = planList.filter(item => {
                return item.clauseName == rule.data.clauseName && item.merge
            })[0]
            if (!clause) {
                continue
            }
            for (let i = 0; i < clause.insuredList.length; i++) {
                if (clause.insuredList[i].insured == clause.selected.insured) {
                    mergeRulesProfessionTypes = mergeRulesProfessionTypes.concat(rule.data.professionTypes[i])
                    break
                }
            }
        }
        mergeRulesProfessionTypes = [...new Set(mergeRulesProfessionTypes)] //去重
    }

    if (allDisable) {
        return []
    }

    result = result.filter(item => {
        if (mergeRulesProfessionTypes && !mergeRulesProfessionTypes.filter(p => {
                return p == item
            }).length) {
            return false
        }

        return !disabledProfessionTypes.filter(type => {
            return type == item
        })[0]
    })

    if (rules && rules.length) {
      for (let rule of rules) {
        if (rule.chooseOne && rule.profession && rule.profession.length) {
          result = filterProfessionTypes(result, planList, rules)
        }
      }
    }

    // console.log("result ======= ", result)


    return result
}
const filterProfessionTypes = function (professionTypes, planList, rules) {
  // console.log(professionTypes, scheme, rules)
  if (professionTypes.length) {
    let arr = []
    for (let rule of rules) {
      if (rule.chooseOne == 1) {
        let dutyMax = rule.dutyMax
        let dutyMin = rule.dutyMin
        let dutyMaxPlan = planList.find(plan => plan.clauseCode == dutyMax)
        let dutyMinPlan = planList.find(plan => plan.clauseCode == dutyMin)
        let realRate = dutyMinPlan.selected.insured / dutyMaxPlan.selected.insured
        // console.log('realRate', realRate)
        if (realRate > 0.1) {
          for (let item of professionTypes) {
            if (['1','2','3'].indexOf(item) > -1) {
              arr.push(item)
            }
          }
        }
      }
    }
    // console.log('arr', arr)
    if (arr.length) {
      return arr
    } else {
      return professionTypes
    }
  } else {
    return professionTypes
  }
}

/**
 * 获取新建的职业
 * */
const getEmptyProfession = function (isAX, firstOfCareeType) {
    if (isAX) {
        return {
            code: '0001001',
            val: 1,
            des: '公务员、职员（内勤）',
            num: 1,
            expendNum: 3,
            personsInfo: [],
            professionError: false
        }
    } else {
        return {
            code: null,
            val: firstOfCareeType && parseInt(firstOfCareeType) ? parseInt(firstOfCareeType) : 1,
            des: null,
            num: 1,
            expendNum: 3,
            personsInfo: [],
            professionError: false
        }
    }

}

/**
 * 获取新建的保障计划
 * @params noProfessions: true: 不需要默认的职业类别；false: 需要默认的职业类别
 * */
const getNewScheme = function (firstOfCareeType, isAX, defaultPlan, noProfessions, deductible, deductibleRate, params, productCombId, disabledRate, factorRate) {
    let professions = []
    if (!noProfessions) {
        professions = [ getEmptyProfession(isAX, firstOfCareeType) ]
    }
    let scheme = {
        planList: JSON.parse(JSON.stringify(defaultPlan.planList)),           //投保计划
        deductible: deductible == undefined ? defaultPlan.deductible : deductible,       //免赔额
        deductibleRate: deductibleRate == undefined ? defaultPlan.deductibleRate: deductibleRate,   //赔付比例
        disabledRate: disabledRate == undefined ? defaultPlan.disabledRate: disabledRate,   //伤残比例
        professions: professions,        //选择的职业信息，以及相关的人员信息
        factorRate: factorRate ? factorRate: []
    }

    if (params && params.deduction && params.deduction.length) {
      let deduction = params.deduction.filter(item => parseFloat(item.productCombId) == parseFloat(productCombId))
      scheme.deductible = deduction && deduction.length ? deduction[0].deductible : scheme.deductible
      scheme.deductibleRate = deduction && deduction.length ? deduction[0].deductibleRate : scheme.deductibleRate
      // scheme.disabledRate = deduction && deduction.length ? deduction[0].disabledRate : scheme.disabledRate
    }
    if(defaultPlan && defaultPlan.planCodes) {
        scheme.planCodes = defaultPlan.planCodes
        scheme.planCodesValue = defaultPlan.planCodesValue
    }
    if (defaultPlan && defaultPlan.withPlanList && defaultPlan.withPlanList.length) {
        scheme.withPlanList = defaultPlan.withPlanList
        scheme.otherPlanValueInfo = {}
    }
    return scheme
}

/**
 * 校验验保障计划
 * */
const checkScheme = function (scheme, schemeIndex, careerType, duration, rules, isAX, clausePremium, personText) {
    let validateInfo = {
        schemePersonNum: 0,
        professions: []
    }
    let professionTypes = getProfessionTypes(careerType, duration, scheme.planList, rules, isAX, clausePremium, scheme.deductible, scheme.deductibleRate, scheme.disabledRate)
    validateInfo.professionTypes = professionTypes
    for (let professionIndex = 0; professionIndex < scheme.professions.length; professionIndex++) {
        let profession = scheme.professions[professionIndex]
        validateInfo.schemePersonNum += profession.num
        validateInfo.professions.push(checkProfession(schemeIndex, professionIndex, profession, professionTypes, personText))
    }
    return validateInfo
}

/**
 * 计算保障计划（价格、提交参数等）
 * */
const calculateScheme = function (scheme, schemeIndex, state, getters) {
    let schemeCalculateInfo = getCalculateSchemeParams(scheme, schemeIndex, state, getters)
    return schemeCalculateInfo
}

const checkAndCalculateScheme = function (scheme, schemeIndex, state, getters) {
    let validateInfo = checkScheme(scheme, schemeIndex, state.careerType, state.duration, state.rules, state.frontControlInfo.isAX, state.clausePremium, state.frontControlInfo.personText)
    let calculateInfo = calculateScheme(scheme, schemeIndex, state, getters)
    Object.assign(validateInfo, calculateInfo)
    return validateInfo
}

/**
 * 获取保障计划提交参数
 * */
const getCalculateSchemeParams = function (scheme, schemeIndex, state, getters) {
    const multiPlan = state.frontControlInfo.multiPlan
    const isNoProfession = state.frontControlInfo.careerType && state.frontControlInfo.careerType.length == 1 && state.frontControlInfo.careerType[0] === '0' ? true : false
    const { shortRateByDuration } = getters

    let result = 0.00
    let allNum = 0
    let groupPolicyJobInfo = []
    let jobTypeClauseInfo = {}
    let groupRuleInfo = {
        jobTypeNumMap: {}
    }
    let personsInfo = []
    let priceRange = null
    let addPriceRange = null
    let planListKey = null
    if (state.planCode && state.premiumRateList) {
        priceRange = []
        addPriceRange = []
        for (let item of state.premiumRateList) {
            priceRange.push({
                planCode: item.planCode,
                premiumRate: item.premiumRate,
                minPrice: 0,
                maxPrice: 0,
            })
            addPriceRange.push({
                planCode: item.planCode,
                premiumRate: item.premiumRate,
                minPrice: 0,
                maxPrice: 0,
            })
        }
    }
    let flag = false

    if (!state.duration) {
        return {
            price: result,
            groupPolicyJobInfo,
            jobTypeClauseInfo,
            groupRuleInfo,
            flag,
            personsInfo,
            planCode: state.planCode,
            priceRange,
        }
    }

    let duration_key = 'D_' + state.duration.duration + state.duration.durationUnit
    let db_key = scheme.deductible !== null ? '_DB_' + scheme.deductible : ''
    let dr_key = scheme.deductibleRate !== null ? '_DR_' + scheme.deductibleRate : ''
    let ddr_key = scheme.disabledRate !== null ? '_DDR_' + scheme.disabledRate : ''

    // 起初没有保费的规则
    let noPriceRules = state.rules.filter(item => {
        return item.noPrice
    })

    let professionPriceList = []

    // 根据所有的已选择的责任，计算出总价格
    let hasPrefess = []
    for (let profession of scheme.professions) {
        hasPrefess.push(profession)

        let professionPriceItem = 0

        let needAddJobTypeClauseInfo = true

        let jobType
        if (isNoProfession) {
          jobType = '000000'
        } else {
          jobType = getJobType(profession.val)
        }
        groupPolicyJobInfo.push({
            jobCode: profession.code,
            jobDesc: profession.des,
            jobType,
            productCombId: String(schemeIndex+1)  // 计划id
        })

        if (!groupRuleInfo.jobTypeNumMap[jobType]) {
            groupRuleInfo.jobTypeNumMap[jobType] = profession.num
        } else {
            groupRuleInfo.jobTypeNumMap[jobType] += profession.num
        }

        if (!jobTypeClauseInfo[jobType]) {
            jobTypeClauseInfo[jobType] = []
        } else {
            needAddJobTypeClauseInfo = false
        }

        let persons = JSON.parse(JSON.stringify(profession.personsInfo || []))

        for (let p of persons) {
            p.occupationCode = profession.code
            p.occupationType = jobType
            p.occupationDesc = profession.des
            if (multiPlan) {
                p.productCombId = schemeIndex + 1
            }
        }

        personsInfo = personsInfo.concat(persons)

        let price = 0;
        let profession_key = '_P_' + (profession.val === null ? '1': profession.val)
        let key1;
        let key2;
        if (isNoProfession) {
          key1 = duration_key
          key2 = duration_key
        } else {
          key1 = duration_key + profession_key
          key2 = duration_key + profession_key + db_key + dr_key + ddr_key
        }

        let list1 = state.clausePremium[key1] //不需要免赔额、赔付比例的责任
        let list2 = state.clausePremium[key2] //需要免赔额、赔付比例的责任
        
        if (list2 && list2.length > 0 && key1 != key2) {
            list1 = list1.concat(list2)
        }

        let multiPlanJobTypeClauseInfo = {
            productCombId: schemeIndex + 1,
            clauseInfoBeanList: []
        }

        for (let plan of scheme.planList) {

            let sameClause = list1.filter(clause => {
                return clause.clauseCode === plan.clauseCode
            })[0]
            if (!sameClause) {
                break
            } else {
                let sameInsured  = sameClause.groupProductPremiumList.filter(premium => {
                    return premium.insured == plan.selected.insured
                })[0]

                if (!sameInsured) {
                    break
                }
                //
                sameInsured.disCountJson = sameClause.disCountJson
                if (sameClause.isPerPerson != undefined) {
                  sameInsured.isPerPerson = sameClause.isPerPerson
                }

                if (state.frontControlInfo.isAX) {
                    if (plan.status == 'isSelected') {
                        let pattern = /^雇主责任/
                        if (pattern.test(plan.clauseName)) {
                            price += sameInsured.premium * state.applyQuantity * profession.num
                        } else {
                            price += sameInsured.premium * state.applyQuantity
                        }
                        if (needAddJobTypeClauseInfo) {
                            if (multiPlan) {
                                multiPlanJobTypeClauseInfo.clauseInfoBeanList.push(sameInsured)
                            } else {
                                jobTypeClauseInfo[jobType].push(sameInsured)
                            }
                        }
                    }
                } else {
                    let noPriceRule = noPriceRules.filter(item => {
                        return item.duty == sameInsured.duty
                    })[0]

                    if (needAddJobTypeClauseInfo) {
                        if (state.planCode && sameInsured.premiumList) {
                            let plItem = sameInsured.premiumList.filter(pm => {
                                return pm.planCode == state.planCode
                            })[0]
                            // if (!plItem) {
                            //     break
                            // }
                            if (!noPriceRule && plItem) {
                                sameInsured.premium = plItem.premium
                                if (plItem.maxPremium) {
                                    sameInsured.maxPremium = plItem.maxPremium
                                }
                            } else {
                                sameInsured.premium = 0
                            }
                            if (plItem) {
                                sameInsured.id = plItem.id
                            }
                        }

                        if (isNoProfession && sameInsured.premiumList && sameInsured.premiumList.length) {
                          let currPremiumId, currPremium, currPremiumItem
                          currPremiumItem = sameInsured.premiumList.find(item => {
                            if (item.attachCondition && JSON.parse(item.attachCondition).insureHouseArea == state.insureHouseArea) {
                              currPremiumId = item.id
                              currPremium = item.premium
                            }
                          })
                          if (currPremiumId) {
                            sameInsured.id = currPremiumId
                          }
                          if (currPremium) {
                            sameInsured.premium = currPremium
                          }
                        }

                        if (multiPlan) {
                            multiPlanJobTypeClauseInfo.clauseInfoBeanList.push(sameInsured)
                        } else {
                            jobTypeClauseInfo[jobType].push(sameInsured)
                        }
                    }
                    if (state.planCode === null) {
                        // console.log(isNoProfession, sameInsured, plan, state)
                        if (isNoProfession) {
                          if (plan.attachPremium && sameInsured.premiumList) {
                            price = Picc.getPrice(state, plan, sameInsured, price)
                          } else {
                            if ([7006,7007].includes(Number(state.productId))) {
                              price += sameInsured.premium
                            }
                            // console.log('责任格式错误，请仿照人保公众责任险数据格式')
                          }
                        } else {

                          if ([94,95].indexOf(Number(state.productId))>-1) {
                            if (hasPrefess.length == 1) {
                              price += sameInsured.premium
                            }
                          } else if ([880,990].indexOf(Number(state.productId))>-1) {
                            // console.log(2222, price, sameInsured, profession, shortRateByDuration)
                            price += sameInsured.premium * shortRateByDuration * profession.num
                          } else {
                            price += sameInsured.premium * profession.num
                          }
                        }
                        // console.log('setPrice', price)
                    } else if (sameInsured.premiumList) {
                        let premiumItem = sameInsured.premiumList.filter(item => {
                            return item.planCode == state.planCode
                        })[0]

                        let priceListByPlanCode = []
                        if (noPriceRule) {
                            let mainPlans = list1.filter(clause => {
                                return noPriceRule.list.filter(item => {
                                    return item == clause.clauseCode
                                }).length
                            })

                            for (let plan of mainPlans) {
                                let realPlan = scheme.planList.find(clause => {
                                    return clause.clauseCode === plan.clauseCode
                                })
                                let planInsured = plan.groupProductPremiumList.find(premium => {
                                    return premium.insured == realPlan.selected.insured
                                })
                                for (let item of planInsured.premiumList || []) {
                                    let priceItem = priceListByPlanCode.find(pi => {
                                        return pi.planCode == item.planCode
                                    })
                                    if (priceItem) {
                                        priceItem.premium += item.premium
                                        priceItem.maxPremium += item.maxPremium
                                    } else {
                                        priceListByPlanCode.push({
                                            planCode: item.planCode,
                                            premium: item.premium,
                                            maxPremium: item.maxPremium
                                        })
                                    }
                                }
                            }

                            for (let item of priceListByPlanCode) {
                                item.premium = item.premium * noPriceRule.rate
                                item.maxPremium = item.maxPremium * noPriceRule.rate
                            }

                            for ( let listItem of sameInsured.premiumList) {
                                let priceItem = priceListByPlanCode.find(value => {
                                    return value.planCode == listItem.planCode
                                })

                                listItem.premium = priceItem.premium
                                listItem.maxPremium = priceItem.maxPremium

                            }
                        }

                        if (premiumItem && premiumItem.maxPremium) {
                            for ( let listItem of sameInsured.premiumList) {
                                let priceRangeItem = priceRange.find(value => {
                                    return value.planCode == listItem.planCode
                                })
                                let addPriceRangeItem = addPriceRange.find(value => {
                                    return value.planCode == listItem.planCode
                                })
                                priceRangeItem.minPrice += listItem.premium * profession.num
                                priceRangeItem.maxPrice += listItem.maxPremium * profession.num

                                if (noPriceRule) {
                                    addPriceRangeItem.minPrice += listItem.premium * profession.num
                                    addPriceRangeItem.maxPrice += listItem.maxPremium * profession.num
                                }
                            }
                        }
                        if ([94,95].indexOf(Number(state.productId))>-1) {
                          if (hasPrefess.length == 1) {
                            price += sameInsured.premium
                          }
                          // price += premiumItem.premium
                        } else if (premiumItem){

                          price += premiumItem.premium * profession.num
                        }
                    } else {
                        if ([94,95].indexOf(Number(state.productId))>-1) {
                          if (hasPrefess.length == 1) {
                            price += sameInsured.premium
                          }
                          // price += sameInsured.premium
                        } else {
                          price += sameInsured.premium * profession.num
                        }
                    }

                }
            }
        }
        if (needAddJobTypeClauseInfo && multiPlan) {
            jobTypeClauseInfo[jobType].push(multiPlanJobTypeClauseInfo)
        }

        allNum += (profession.num || 1)
        result += price

        professionPriceItem = price

        professionPriceList.push(professionPriceItem)
    }

    // result = parseFloat(result.toFixed(2))
    result = parseFloat(result)

    // 价格重置：复业报7002，前两个责任价格不与人数进行变动，这部分价格需要减除, IsPerPerson: 0-不加, 1-要加
    // let schemePlanListHasIsPerPerson = state.schemes[0].planList.find(item => item.isPerPerson === 0)
    // if (schemePlanListHasIsPerPerson) {
    //   let copeSubmitParamsPrice = result
    //   let jobTypeClauseInfoIndex = 0
    //   let isPerPersonPriceTol = 0
    //   for(let key in jobTypeClauseInfo) {
    //     if (jobTypeClauseInfoIndex === 0) {
    //       let plan = jobTypeClauseInfo[key]
    //       for(let index=0,len=plan.length; index<=len; index++) {
    //         let premium = plan[index] && plan[index].isPerPerson === 0 ? plan[index].premium : 0
    //         if (premium) {
    //           isPerPersonPriceTol += premium
    //         }
    //       }
    //       jobTypeClauseInfoIndex++
    //     }
    //   }
    //   console.log('isPerPersonPriceTol', isPerPersonPriceTol)
    //   result = copeSubmitParamsPrice - (isPerPersonPriceTol * (allNum - 1))
    // }

    flag = true

    if (priceRange) {
        priceRange.sort((a, b) => {
            return a.premiumRate > b.premiumRate
        })
        if (!priceRange.filter(item => {
                return item.minPrice != 0
            }).length) {
            priceRange = null
            addPriceRange = null
        }
    }

    // if ([98].indexOf(Number(state.productId))>-1) {
    //   priceRange = null
    //   addPriceRange = null
    // }

    planListKey= ''
    for (let plan of scheme.planList) {
        if (plan.merge) {
            continue
        }
        planListKey = (planListKey ? planListKey + '&' : '') + `${plan.clauseCode}-${plan.selected.insured}`
    }

    return {
        allNum: allNum,
        price: result,
        groupPolicyJobInfo,
        jobTypeClauseInfo,
        groupRuleInfo,
        flag,
        personsInfo,
        planCode: state.planCode,
        priceRange,
        addPriceRange,
        planListKey,
        professionPriceList: professionPriceList,
        deduction: [{
          productCombId: schemeIndex+1,
          deductible: scheme.deductible, // 免赔额
          deductibleRate: scheme.deductibleRate, // 免赔率
        }],
        withPlanList: scheme.withPlanList || []
    }
}

/**
 * 对 schemesInfo 每项信息进行二次加工，获得二次数据，如折扣价格、
 * */
const getTwiceTransformSchemesInfo = function(state, schemesInfo) {
  // console.log(state, schemesInfo)
  let cloneSchemesInfo = JSON.parse(JSON.stringify(schemesInfo))
  let discountList = state.discountList, discount = 1, totalMoney = 0
  let personAllNum = 0
  let productId = state.productId
  for (let scheme of cloneSchemesInfo) {
    personAllNum += scheme.allNum
  }
  //折扣价格计算
  if (discountList && discountList.length > 0) {
      for (const item of discountList) {
          if (
              (!item.minN || (item.minN && item.minN <= personAllNum))
              && (!item.maxN || (item.maxN && item.maxN >= personAllNum))
          ) {
              discount = item.dicount;
              break;
          }
      }
  }

  for (let scheme of cloneSchemesInfo) {
    scheme.disPrice = scheme.price * discount
    scheme.disPrice = parseFloat(scheme.disPrice.toFixed(2))
  }
  // console.log('总人数', personAllNum)
  // console.log('总折扣（discount）: ', discount)
  // 复保折扣价计算
  // 保费计算规则，比如：一个被保人投保意外身故保费51.2，医疗责任61.2，总人数101人，那么保费实际计算是（round（round（51.2）*0.95）+round（round（61.2）*0.95））*101
  let hasClauseDisCount = false
  try {
    for (let plan of cloneSchemesInfo) {
      for (let jobType in plan.jobTypeClauseInfo) {
        for (let job of plan.jobTypeClauseInfo[jobType]) {
          if (job.clauseInfoBeanList && job.clauseInfoBeanList.length) {
            for (let clause of job.clauseInfoBeanList) {
              if (clause.disCountJson) {
                hasClauseDisCount = true
                break
              }
            }
          }
        }
      }
    }
  } catch (error) {

  }
  // console.log('hasClauseDisCount', hasClauseDisCount)
  if (cloneSchemesInfo && cloneSchemesInfo.length && hasClauseDisCount) {
      for (let schemeIndex = 0; schemeIndex < cloneSchemesInfo.length; schemeIndex++) {
        let info = cloneSchemesInfo[schemeIndex]
        //每个计划计算
        let jobTypeMoney = 0
        // schemesInfo[0]
        // 多计划
        for (let jobType in info.jobTypeClauseInfo) {
          let personLength = parseFloat(info.groupRuleInfo.jobTypeNumMap[jobType])
          // schemesInfo[0].jobTypeClauseInfo['000100']
          // 当前计划的多职业
          for (let job of info.jobTypeClauseInfo[jobType]) { //这里有难点
            // jobTypeMoney = 0
            // 当前职业的 每个责任计算
            for (let clause of job.clauseInfoBeanList) {
              if (clause.premium) {
                //责任折扣信息
                let clauseDisCount = 1
                if (clause.disCountJson) {
                  let disCountJson = JSON.parse(clause.disCountJson)
                  //数量信息
                  for (let countData of disCountJson.priceDisCount) {
                    if (personAllNum >= countData.minN && personAllNum <= countData.maxN) {
                      clauseDisCount = countData.disCount
                    }
                  }
                  //取整方式（0:向上取整） 小数位数
                  //影响人数计算的类型（1:整个保单人数）
                }
                if ([202, 203].indexOf(Number(productId))>-1) { // 计算总价 之后四舍五入
                  jobTypeMoney += (clause.premium * clauseDisCount * personLength)
                } else if ([204].indexOf(Number(productId))>-1) { // 责任四舍五入 相加总价
                  jobTypeMoney += (Number((clause.premium * clauseDisCount).toFixed(2)) * personLength)
                } else { // 向上取整版本
                  jobTypeMoney += Math.ceil(Math.ceil(Math.ceil(clause.premium) * clauseDisCount) * personLength)
                }
                console.log('计划:', job.productCombId, '，职业类别:', jobType, '，责任:', clause.strDesc, '，价格:', clause.premium, '，折扣:', clauseDisCount, '，人数为:', personLength, '，累计价格为：', jobTypeMoney)
              }
            }
            if (jobTypeMoney) {
              if ([202, 203, 204].indexOf(Number(productId))>-1) { // 四舍五入版本
                totalMoney = parseFloat(jobTypeMoney.toFixed(2))
              // } else if ([204].indexOf(Number(productId))>-1) {
                // totalMoney += Number(jobTypeMoney.toFixed(2)) * personLength
              } else { // 向上取整版本
                totalMoney = Math.ceil(jobTypeMoney)
              }
            }
          }
        }

        console.log('复保schemesInfo折扣价格为: ', totalMoney)
        cloneSchemesInfo[schemeIndex].disPrice = parseFloat(totalMoney.toFixed(2))
      }
  }

  // 价格重置：复业报7002，前两个责任价格不与人数进行变动，这部分价格需要减除, IsPerPerson: 0-不加, 1-要加
  let schemePlanListHasIsPerPerson = state.schemes[0] && state.schemes[0].planList.find(item => item.isPerPerson === 0)
  if (schemePlanListHasIsPerPerson) {
    for (let schemeIndex = 0; schemeIndex < cloneSchemesInfo.length; schemeIndex++) {
      let info = cloneSchemesInfo[schemeIndex]
      let copeSubmitParamsPrice = info.disPrice
      let jobTypeClauseInfoIndex = 0
      let isPerPersonPriceTol = 0
      for(let key in info.jobTypeClauseInfo) {
        if (jobTypeClauseInfoIndex === 0) {
          let plan = info.jobTypeClauseInfo[key]
          for(let index=0,len=plan.length; index<=len; index++) {
            let premium = plan[index] && plan[index].isPerPerson === 0 ? plan[index].premium : 0
            if (premium) {
              isPerPersonPriceTol += premium
            }
          }
          jobTypeClauseInfoIndex++
        }
      }
      console.log('isPerPersonPriceTol', isPerPersonPriceTol)
      cloneSchemesInfo[schemeIndex].disPrice = copeSubmitParamsPrice - (isPerPersonPriceTol * (info.allNum - 1))
    }
  }

  return cloneSchemesInfo
}

/**
 * 校验职业类别
 * */
const checkProfession = function (schemeIndex, professionIndex, profession, professionTypes, personText) {
    let professionError = false
    let errorMsg = ''
    if (!profession.code) {
        professionError = true
        errorMsg = `保障计划${customFunc.numberToChinese(schemeIndex + 1)}中第${professionIndex + 1}类职业还未选择，请选择`
    } else if (!professionTypes.find(type => {
            return type == profession.val
        })) {
        professionError = true
        errorMsg = `保障计划${customFunc.numberToChinese(schemeIndex + 1)}不支持${profession.val}类职业投保`
    }
    return { professionError, errorMsg, ...profession, occupationType: getJobType(profession.val)}
}

/**
 * 获取职业类型
 * 把职业类型'1' 转换成 '100000'
 * */
const getJobType = function (val) {
    let jobType = ''
    for (let i = 0; i < 6; i++) {
        if (val == i + 1) {
            jobType += '1'
        } else {
            jobType += '0'
        }
    }
    return jobType
}
/**
 * 检验是否符合当前产品职业
 * */
const checkProductProfess = function(state, profess) {
    console.log('addressSearchList', state, profess)
    const addressSearchList = state.addressSearchList
    let checked = false
    // 兼容 其他页面 不是投保页的职业展示
    if (!addressSearchList || !addressSearchList.length) {
      return true
    }
    // 投保页的职业展示 - 连续投保
    if (!profess || !profess.code || !profess.des) {
      checked = false
    }
    addressSearchList.forEach(address => {
      if (address && address[2] && address[2].code && address[2].code == profess.code && !address[2].val.includes('拒保')) {
        checked = true
      }
    })
    return checked
  }

/**
 * 根据订单数据，初始化保障计划数据
 * */
const getSchemesByOrderParams = function (state, params) {
    let schemes = []
    let hasCombId = false // 单计划
    let orderDetailJson = params.detailJson ? JSON.parse(params.detailJson) : null
    let multiPlanAndMultiProfessionFromOrder = orderDetailJson ? orderDetailJson.multiPlanAndMultiProfession : null  //0或null，标志原来的订单，1表示现在订单
    let orderStatus = orderDetailJson && multiPlanAndMultiProfessionFromOrder ? true : false

    for (let jobType in params.jobTypeClauseInfo) {
        if (params.jobTypeClauseInfo[jobType][0].productCombId) {
            hasCombId = true // 多计划
        }
    }
    // 多计划连续投保单计划的处理情况
    const frontControlInfo = state.frontControlInfo
    const multiPlan = frontControlInfo.multiPlan

    let isTest = true
    if (['331', '332', '338'].includes((params.productId + ''))  || Number(multiPlan) === 0 && frontControlInfo.multiProfession && frontControlInfo.needToPremiumTrial) {
        isTest = false
    }

    if (!hasCombId && isTest) {
        for (let jobType in params.jobTypeClauseInfo) {
            let scheme = findSameScheme(schemes, params.jobTypeClauseInfo[jobType])
            if (!scheme) {
                scheme = getNewScheme(state.frontControlInfo.careerType[0], state.frontControlInfo.isAX, state.defaultPlan, true, params.deductible, params.deductibleRate, params.disabledRate, params.factorRate)
                setSchemePlanListByPremiumList(state, scheme, params.jobTypeClauseInfo[jobType], params.recommend)
                schemes.push(scheme)
            }
            for (let job of params.groupPolicyJobInfo) {
                if (job.jobType == jobType) {
                    let profession = getEmptyProfession(state.frontControlInfo.isAX, state.frontControlInfo.careerType[0])
                    profession.code = job.jobCode
                    profession.des = job.jobDesc
                    profession.val = job.jobType.indexOf('1') + 1

                    let personsInfo = params.personsInfo.filter(p => {
                        return p.occupationCode == job.jobCode
                    })
                    // 把身份证最后一位字母转成大写
                    for (let person of personsInfo) {
                        if (person.insuredIdType == 1 && person.insuredIdNo) {
                            person.insuredIdNo = person.insuredIdNo.toUpperCase()
                        }
                    }
                    profession.personsInfo = personsInfo
                    profession.num = personsInfo.length

                    // 职业检测不符合
                    if (!checkProductProfess(state, profession)) {
                      profession.des = ''
                      profession.code = ''
                    }

                    if (params.recommend) {  //续保推荐
                        profession.des = ''
                        profession.code = ''
                    }
                    scheme.professions.push(profession)
                }
            }
        }
    }  else if (Number(multiPlan) === 0 && hasCombId && isTest) {
        const vm = params._self
        // const message = '当前产品是单计划的，数据进行重置，请重新填写连续投保数据！'
        // vm.$messagebox.alert(message).then(() => {
        // })
        // 多计划连续投保单计划的处理情况
        let scheme = getNewScheme(state.frontControlInfo.careerType[0], state.frontControlInfo.isAX, state.defaultPlan)
        console.log('产品是单计划的 scheme', scheme)
        // 获取第一个计划下的数据
        let firstPlanInfo = params.groupPolicyJobInfo[0]
        console.log('产品是单计划的 firstPlanInfo', firstPlanInfo)
        let profession = getEmptyProfession(state.frontControlInfo.isAX, state.frontControlInfo.careerType[0])
        profession.code = firstPlanInfo.jobCode
        profession.des = firstPlanInfo.jobDesc
        profession.val = firstPlanInfo.jobType.indexOf('1') + 1

        let personsInfo = params.personsInfo.filter(p => {
            return p.occupationCode == firstPlanInfo.jobCode
        })
        // 把身份证最后一位字母转成大写
        for (let person of personsInfo) {
            if (person.insuredIdType == 1 && person.insuredIdNo) {
                person.insuredIdNo = person.insuredIdNo.toUpperCase()
            }
        }
        profession.personsInfo = personsInfo
        profession.num = personsInfo.length

        // 职业检测不符合
        if (!checkProductProfess(state, profession)) {
          profession.des = ''
          profession.code = ''
        }

        if (params.recommend) {  //连续投保推荐
            profession.des = ''
            profession.code = ''
        }
        scheme.professions[0] = profession

        schemes.push(scheme)
    } else {
        let combIdList = []; //已添加的productCombId列表
        for (let jobType in params.jobTypeClauseInfo) {
            for (let comb of params.jobTypeClauseInfo[jobType]) {
                let scheme = null
                if (combIdList.indexOf(comb.productCombId) == -1) {
                    combIdList.push(comb.productCombId)
                    scheme = getNewScheme(state.frontControlInfo.careerType[0], state.frontControlInfo.isAX, state.defaultPlan, true, params.deductible, params.deductibleRate, params, comb.productCombId, params.disabledRate, params.factorRate)
                    scheme.productCombId = comb.productCombId
                    setSchemePlanListByPremiumList(state, scheme, comb.clauseInfoBeanList, params.recommend)

                    // 根据productCombId的大小来判断scheme的插入顺序
                    let index = combIdList.filter(combId => {
                        return combId - 0 < scheme.productCombId - 0
                    }).length
                    schemes.splice(index, 0, scheme)
                } else {
                    scheme = findSameScheme(schemes, comb.clauseInfoBeanList)
                }

                //组装被保人信息
                for (let job of params.groupPolicyJobInfo) {
                    // console.log('params.groupPolicyJobInfo ==', params.groupPolicyJobInfo)
                    if (state.frontControlInfo.multiPlanAndMultiProfession && ((orderDetailJson && orderStatus) || !orderDetailJson)) {
                        if (job.jobType == jobType && job.productCombId == comb.productCombId) {
                            let profession = getEmptyProfession(state.frontControlInfo.isAX, state.frontControlInfo.careerType[0])
                            profession.code = job.jobCode
                            profession.des = job.jobDesc
                            profession.val = job.jobType.indexOf('1') + 1

                            let personsInfo = params.personsInfo.filter(p => {
                                return p.occupationCode == job.jobCode && p.productCombId == job.productCombId && p.occupationDesc == job.jobDesc
                            })
                            // 把身份证最后一位字母转成大写
                            for (let person of personsInfo) {
                                if (person.insuredIdType == 1 && person.insuredIdNo) {
                                    person.insuredIdNo = person.insuredIdNo.toUpperCase()
                                }
                            }
                            profession.personsInfo = personsInfo
                            profession.num = personsInfo.length

                            // 职业检测不符合
                            if (!checkProductProfess(state, profession)) {
                                profession.des = ''
                                profession.code = ''
                            }
                            if (params.recommend) {  //续保推荐
                                profession.des = ''
                                profession.code = ''
                            }

                            //scheme.professions 去重
                            if (scheme.professions && scheme.professions.length && scheme.professions.some(profess => profess.code == profession.code && profess.des == profession.des && profess.productCombId == profession.productCombId)) {
                              continue
                            }
                            scheme.professions.push(profession)
                        }
                    } else {
                        let ifInfoOne = (job.jobType == jobType) ? true : false
                        let spPro = ['80129'].includes((params.productId + '')) ? true : false
                        if (spPro) {
                            ifInfoOne = (job.jobType == jobType && job.productCombId == comb.productCombId) ? true : false
                        }
                        if (ifInfoOne) {
                            let profession = getEmptyProfession(state.frontControlInfo.isAX, state.frontControlInfo.careerType[0])
                            profession.code = job.jobCode
                            profession.des = job.jobDesc
                            profession.val = job.jobType.indexOf('1') + 1

                            let personsInfo = params.personsInfo.filter(p => {
                                return p.occupationCode == job.jobCode && (p.productCombId == job.productCombId && spPro || !spPro)
                            })
                            // 把身份证最后一位字母转成大写
                            for (let person of personsInfo) {
                                if (person.insuredIdType == 1 && person.insuredIdNo) {
                                    person.insuredIdNo = person.insuredIdNo.toUpperCase()
                                }
                            }
                            profession.personsInfo = personsInfo
                            profession.num = personsInfo.length

                            // 职业检测不符合
                            if (!checkProductProfess(state, profession)) {
                                profession.des = ''
                                profession.code = ''
                            }

                            if (params.recommend) {  //续保推荐
                                profession.des = ''
                                profession.code = ''
                            }
                            // lml-scheme不存在时重新查询
                            if(!scheme) {
                                scheme = schemes.find(_ => job.productCombId == _.productCombId)
                            };
                            // lml-未知原因导致scheme不存在，查找花费时间太多
                            if(scheme){
                                scheme.professions.push(profession)
                            }
                        }
                    }
                }
            }
        }
    }

    // 如果职业的人数为0，则把人数设置为1（这种情况一般是待完善订单才会出现的）
    if (!state.frontControlInfo.isAX) {
        for (let scheme of schemes) {
            for (let profession of scheme.professions) {
                if (profession.num == 0) {
                    profession.num = 1
                }
            }
        }
    }

    return schemes
}

const findSameScheme = function (schemes, planList) {
    for (let scheme of schemes) {
        let flag = true
        for (let plan of planList) {
            let samePlan = scheme.planList.find(item => {
                return item.clauseCode == plan.duty && item.selected.insured != plan.insured
            })
            if (samePlan) {
                flag = false
            }
        }
        if (flag) {
            return scheme
        }
    }
    return null
}

/**
 * 根据premiumList数据，设置 scheme 的 planList
 * */
const setSchemePlanListByPremiumList = function (state, scheme, premiumList, recommend) {
    if (!recommend) {
        for (let premium of premiumList) {
            let plan = scheme.planList.filter(plan => {
                return plan.clauseCode == premium.duty
            })[0]

            if (plan) {
                let samePremium = null
                if (state.frontControlInfo && state.frontControlInfo.isAX) {
                    //做特殊处理，为了兼容改造前老板安心老订单的insured字段和改造后不一致的问题
                    samePremium = plan.insuredList.filter(insured => {
                        return insured.insured == premium.insured || plan.outDutyCode == premium.productCode
                    })[0]
                } else {
                    samePremium = plan.insuredList.filter(insured => {
                        return insured.insured == premium.insured
                    })[0]
                }
                if (samePremium) {
                    plan.selected = samePremium
                }

                if (state.frontControlInfo && state.frontControlInfo.isAX) {
                    if (samePremium) {
                        plan.status = 'isSelected'
                        plan.isSelected = 1
                    } else {
                        plan.isSelected = 0
                    }

                }
            }
        }
    } else {

        // 续保，不需要考虑老板安心的情况
        let mainClauseList = ['AD001', 'AM001', 'AH001']
        for (let [index, premium] of premiumList.slice(0, 3).entries()) {
            let plan = scheme.planList.filter(plan => {
                return plan.allClauseCode == mainClauseList[index]
            })[0]

            if (plan) {
                let samePremium = null
                samePremium = plan.insuredList.filter(insured => {
                    return insured.insured == premium.insured
                })[0]

                if (samePremium) {
                    plan.selected = samePremium
                }
            }
        }
    }

    if (state.frontControlInfo && state.frontControlInfo.isAX) {
        let plan = scheme.planList.filter(item => {
            return item.firstPlaceDuty
        })[0]

        if (plan) {
            for (let item of scheme.planList) {
                let pattern = /^场所责任/g
                if (pattern.test(item.clauseName)) {
                    if (!item.firstPlaceDuty) {
                        if (plan.status == 'isSelectable') {
                            item.status = 'isDisabled'
                        } else if (plan.status=='isSelected' && item.status == 'isDisabled') {
                            item.status = 'isSelectable'
                        }
                    }

                }
            }
        }
    }

    // 设置合并责任选中的选项
    let mergeClauses = scheme.planList.filter(item => {
        return item.merge
    })
    for (let item of mergeClauses) {

        let duty = state.rules.filter(rule => {
            return rule.data && rule.data.clauseName == item.clauseName
        })[0]

        let clauses = []
        for (let d of duty.data.dutyList) {
            let clause = scheme.planList.filter(plan => {
                return plan.clauseCode == d
            })[0]
            clauses.push(clause)
        }
        let mergeInsured = clauses.map(c => {
            return c.selected.insured
        }).join('&')
        console.log('合并责任的选项', mergeInsured)

        let sameInsured = item.insuredList.filter(item => {
            return item.insured == mergeInsured
        })[0]
        if (sameInsured) {
            console.log('setSchemePlanListByPremiumList 找到了merge责任的选项', item, sameInsured)
            item.selected = sameInsured
        } else {
            console.log('setSchemePlanListByPremiumList 找不到选项:' + sameInsured)
        }
    }
    return scheme
}


/**
 * 根据职业类别重新获取planList(用于产品详情页)
 * */
const getNewPlanListByProfession = function (schemes, duration, clausePremium, isAX, schemeIndex, professionIndex) {
    let scheme = schemes[schemeIndex]
    let profession = scheme.professions[professionIndex]

    if (!profession || !profession.val || !duration || isAX) {
        return scheme.planList
    } else {
        let Dkey = 'D_' + duration.duration + duration.durationUnit
        let Pkey = '_P_' + profession.val

        let db_key = scheme.deductible !== null ? '_DB_' + scheme.deductible : ''
        let dr_key = scheme.deductibleRate !== null ? '_DR_' + scheme.deductibleRate : ''
        let ddr_key = scheme.disabledRate !== null ? '_DDR_' + scheme.disabledRate : ''

        let list = clausePremium[Dkey + Pkey]

        console.log('db_key', db_key, 'dr_key', dr_key)
        if (db_key + dr_key + ddr_key != '') {
            let list2 = clausePremium[Dkey + Pkey + db_key + dr_key + ddr_key]
            list = list.concat(list2)
        }

        let newPlanList = JSON.parse(JSON.stringify(scheme.planList))
        for (let item of newPlanList) {
            let theSameClause = list.filter(clause => {
                return clause.clauseCode == item.clauseCode
            })[0]
            if (theSameClause) {
                for (let i = 0; i < item.insuredList.length; i++) {
                    let theSamePremium = theSameClause.groupProductPremiumList.filter(premium => {
                        return premium.insured == item.insuredList[i].insured
                    })[0]
                    if (!theSamePremium) {
                        item.insuredList.splice(i, 1)
                        i--
                    }
                }
            }
        }

        return newPlanList
    }
}

/**
 * 根据职业类别重新获取planList(用于产品详情页)
 * */
const getNewPlanListByProfessionNew = function (schemes, duration, clausePremium, isAX, schemeIndex, deductible, deductibleRate) {
    let scheme = schemes[schemeIndex]
    let profession = scheme.professions
    if (!profession || !profession.val || !duration || isAX) {
        return scheme.planList
    } else {
        let Dkey = 'D_' + duration.duration + duration.durationUnit
        let Pkey = '_P_' + profession.val

        let db_key = deductible !== null ? '_DB_' + deductible : ''
        let dr_key = deductibleRate !== null ? '_DR_' + deductibleRate : ''

        let list = clausePremium[Dkey + Pkey]

        // console.log('db_key', db_key, 'dr_key', dr_key)
        if (db_key + dr_key != '') {
            let list2 = clausePremium[Dkey + Pkey + db_key + dr_key]
            if (list2) {
                list = list.concat(list2)
            }
        }

        let newPlanList = JSON.parse(JSON.stringify(scheme.planList))
        for (let item of newPlanList) {
            let theSameClause = list && list.filter(clause => {
                return clause.clauseCode == item.clauseCode
            })[0]
            if (theSameClause) {
                for (let i = 0; i < item.insuredList.length; i++) {
                    let theSamePremium = theSameClause.groupProductPremiumList.filter(premium => {
                        return premium.insured == item.insuredList[i].insured
                    })[0]
                    if (!theSamePremium) {
                        item.insuredList.splice(i, 1)
                        i--
                    }
                }
            }
        }

        return newPlanList
    }
}

/**
 * 免赔额 & 赔付比例逻辑
 * */
const checkDeductible = function(data, productMsg = data.productMsg) {
  // debugger
  const {jobTypeClauseInfo, detailJson} = data
  const detailJsonData = JSON.parse(detailJson  || '{}')
  let params = {}
  if (productMsg && productMsg.deductible && productMsg.deductible.deductible && productMsg.deductible.deductible.length > 0) {
    if (detailJsonData && detailJsonData.deductible) {
      params.deductible = detailJsonData.deductible
    } else {
      if (getObjectFirstAttribute(jobTypeClauseInfo)
      && getObjectFirstAttribute(jobTypeClauseInfo).length > 0
      && getObjectFirstAttribute(jobTypeClauseInfo).some(item => item.strDesc === productMsg.deductible.deductible[0].name)) {
        getObjectFirstAttribute(jobTypeClauseInfo).forEach(item => {
          if (item.strDesc === productMsg.deductible.deductible[0].name) {
            params.deductible = item.insured
            return
          }
        })
      } else {
        params.deductible = 0
      }
    }
  } else {
    params.deductible = undefined
  }

  if (productMsg && productMsg.deductible && productMsg.deductible.deductibleRate && productMsg.deductible.deductibleRate.length > 0) {
    if (detailJsonData && detailJsonData.deductibleRate) {
      params.deductibleRate = detailJsonData.deductibleRate
    } else {
      if (getObjectFirstAttribute(jobTypeClauseInfo)
        && getObjectFirstAttribute(jobTypeClauseInfo).length > 0
        && getObjectFirstAttribute(jobTypeClauseInfo).some(item => item.strDesc === productMsg.deductible.deductibleRate[0].name)) {
        getObjectFirstAttribute(jobTypeClauseInfo).forEach(item => {
          if (item.strDesc === productMsg.deductible.deductibleRate[0].name) {
            params.deductibleRate = item.insured
            return
          }
        })
      } else {
        params.deductibleRate = 100
      }
    }
  } else {
    params.deductibleRate = undefined
  }

  if (productMsg && productMsg.deductible && productMsg.deductible.disabledRate && productMsg.deductible.disabledRate.length > 0) {
    if (detailJsonData && detailJsonData.disabledRate) {
      params.disabledRate = detailJsonData.disabledRate
    } else {
      if (getObjectFirstAttribute(jobTypeClauseInfo)
        && getObjectFirstAttribute(jobTypeClauseInfo).length > 0
        && getObjectFirstAttribute(jobTypeClauseInfo).some(item => item.strDesc === productMsg.deductible.disabledRate[0].name)) {
        getObjectFirstAttribute(jobTypeClauseInfo).forEach(item => {
          if (item.strDesc === productMsg.deductible.disabledRate[0].name) {
            params.disabledRate = item.insured
            return
          }
        })
      } else {
        params.disabledRate = 100
      }
    }
  } else {
    params.disabledRate = undefined
  }

  return params
}

function getObjectFirstAttribute(obj) {
  for (let key in obj) {
    return obj[key]
  }
}

export default {
    getProfessionTypes,
    getEmptyProfession,
    getNewScheme,
    checkScheme,
    calculateScheme,
    checkAndCalculateScheme,
    getCalculateSchemeParams,
    checkProfession,
    getJobType,
    getSchemesByOrderParams,
    findSameScheme,
    setSchemePlanListByPremiumList,
    getNewPlanListByProfession,
    checkDeductible,
    getTwiceTransformSchemesInfo,
    getNewPlanListByProfessionNew,
}




// WEBPACK FOOTER //
// ./src/util/orderFun.js